import styled, { css } from 'styled-components'

export const IdColumn = styled.div`
  display: flex;
  align-items: center;
  width: 100px;
  gap: 5px;
`

export const NotesCell = styled.div`
  width: 220px;
  max-width: 220px;
`

export const NotesText = styled.span<{ $expanded: boolean }>`
  color: var(--theme-colors-global-general-secondary);
  display: inline;
  white-space: ${(p) => (p.$expanded ? 'pre-line' : 'normal')};
  word-break: break-word;
`

export const NotesToggleLink = styled.a`
  margin-left: 8px;
  font-style: italic;
  cursor: pointer;
`

const EmailAndPhoneStyle = css`
  font-size: 12px !important;
  font-weight: 600;
  line-height: 15px !important;
  letter-spacing: 0.24px;
  white-space: nowrap;
  color: var(--theme-colors-global-general-secondary) !important;
  text-decoration: none;
`

export const Phone = styled.div`
  ${EmailAndPhoneStyle}
`

export const EmailLink = styled.a`
  ${EmailAndPhoneStyle}
`
